module.exports = __webpack_public_path__ + "img/T901.7e5bd112.jpg";